import { render, staticRenderFns } from "./RegionList.vue?vue&type=template&id=c35121fa&scoped=true"
import script from "./RegionList.vue?vue&type=script&lang=js"
export * from "./RegionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35121fa",
  null
  
)

export default component.exports